import type { SpreadsheetCommandId } from './commandRegistry'

export type RibbonControllerCommandId = Extract<
  SpreadsheetCommandId,
  | 'undo'
  | 'redo'
  | 'paste'
  | 'cut'
  | 'copy'
  | 'format-painter'
  | 'autosum'
  | 'insert-table'
  | 'remove-duplicates'
  | 'sort-filter'
  | 'find'
  | 'replace'
  | 'import-data'
  | 'import-excel-workbook'
  | 'export-excel-workbook'
  | 'query-builder'
  | 'fullscreen'
>

export type RibbonControllerCommandPlan =
  | { action: 'undo' }
  | { action: 'redo' }
  | { action: 'perform-paste' }
  | { action: 'perform-cut' }
  | { action: 'perform-copy' }
  | { action: 'activate-format-painter' }
  | { action: 'start-autosum' }
  | { action: 'create-table' }
  | { action: 'remove-duplicates' }
  | { action: 'apply-autofilter' }
  | { action: 'open-find'; mode: 'find' | 'replace' }
  | { action: 'import-data' }
  | { action: 'import-excel-workbook' }
  | { action: 'export-excel-workbook' }
  | { action: 'toggle-query' }
  | { action: 'toggle-fullscreen' }

const RIBBON_CONTROLLER_COMMAND_PLANS: Record<RibbonControllerCommandId, RibbonControllerCommandPlan> = {
  undo: { action: 'undo' },
  redo: { action: 'redo' },
  paste: { action: 'perform-paste' },
  cut: { action: 'perform-cut' },
  copy: { action: 'perform-copy' },
  'format-painter': { action: 'activate-format-painter' },
  autosum: { action: 'start-autosum' },
  'insert-table': { action: 'create-table' },
  'remove-duplicates': { action: 'remove-duplicates' },
  'sort-filter': { action: 'apply-autofilter' },
  find: { action: 'open-find', mode: 'find' },
  replace: { action: 'open-find', mode: 'replace' },
  'import-data': { action: 'import-data' },
  'import-excel-workbook': { action: 'import-excel-workbook' },
  'export-excel-workbook': { action: 'export-excel-workbook' },
  'query-builder': { action: 'toggle-query' },
  fullscreen: { action: 'toggle-fullscreen' },
}

export function buildRibbonControllerCommandPlan(
  commandId: SpreadsheetCommandId,
): RibbonControllerCommandPlan | undefined {
  return RIBBON_CONTROLLER_COMMAND_PLANS[commandId as RibbonControllerCommandId]
}
